import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function P1DoorStickerMerchandisingPage({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    // Clear error for this field when user starts typing/selecting
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validate = () => {
    const newErrors = {
      door_sticker_visible: !primaryDetails.door_sticker_visible,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    
    if (hasErrors) {
      toast.error("Please select an option for visible P1 door sticker", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };  

  const handleSubmit = () => {
   

    if (validate()) {
      
      if (primaryDetails.door_sticker_visible === 'Yes') {
        navigation.go('p1-door-sticker-details');
      } else if (primaryDetails.door_sticker_visible === 'No') {
        navigation.go('not-visible-p1-door-sticker');
      } else {
      }
    } 
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">P1 DOOR STICKER MERCHANDISING</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">

              <Form>

                {/* Visible P1 door sticker */}
                <Form.Group className={`mb-4 ${errors.door_sticker_visible ? 'form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    Visible P1 door sticker <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Text className="form-hint">
                    Pag visit mo, may nakita ka bang naka-install na P1 door sticker
                  </Form.Text>
                  <div className="form-radio-group">
                    <div className={`form-radio-item${primaryDetails.door_sticker_visible === 'Yes' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="door_sticker_visible"
                          value="Yes"
                          label="Yes"
                          checked={primaryDetails.door_sticker_visible === 'Yes'}
                          onChange={handleChange}
                          className="form-radio"
                        />
                      </div>
                    </div>
                    <div className={`form-radio-item${primaryDetails.door_sticker_visible === 'No' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="door_sticker_visible"
                          value="No"
                          label="No"
                          checked={primaryDetails.door_sticker_visible === 'No'}
                          onChange={handleChange}
                          className="form-radio"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.door_sticker_visible && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                    Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default P1DoorStickerMerchandisingPage;
